import React from 'react';
// STYLE
import Button from '@material-ui/core/Button';
// API
import { REQUEST_ITEM } from '../mutation';
// HOOKS
import { useMutation, useReactiveVar } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { userInfoVar } from '../../../../apollo/localState/userInfoVar';

const HoldingsTableOperationColumnRequestItemButton = ({ item }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [requestItem, { loading }] = useMutation(REQUEST_ITEM, {
    refetchQueries: [
      'searchBibItems',
      'fetchMyTransactions',
      'fetchMyTransactionsCount',
    ],
  });

  const { isMemberCardActive } = useReactiveVar(userInfoVar);

  const requestClickedHandler = () => {
    if (loading || !isMemberCardActive) return;

    const targetItem = { guid: item.guid };

    requestItem({
      variables: {
        data: {
          targetItem,
        },
      },
    }).then(res => {
      enqueueSnackbar(`Sikeres előjegyzés`, {
        variant: 'success',
      });
    });
  };

  return (
    <Button
      color="primary"
      onClick={requestClickedHandler}
      variant="outlined"
      size="small"
      disabled={!isMemberCardActive || loading}
    >
      Előjegyzés
    </Button>
  );
};

export default HoldingsTableOperationColumnRequestItemButton;
